import PromoDetailPage from "./PromoDetailPage";
export default PromoDetailPage